/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrderEntry } from './OrderEntry';
import {
    OrderEntryFromJSON,
    OrderEntryFromJSONTyped,
    OrderEntryToJSON,
} from './OrderEntry';

/**
 * Representation of a Consignment Entry
 * @export
 * @interface ConsignmentEntry
 */
export interface ConsignmentEntry {
    /**
     * 
     * @type {OrderEntry}
     * @memberof ConsignmentEntry
     */
    orderEntry?: OrderEntry;
    /**
     * Quantity value of Consignment entry
     * @type {number}
     * @memberof ConsignmentEntry
     */
    quantity?: number;
    /**
     * Shipped quantity
     * @type {number}
     * @memberof ConsignmentEntry
     */
    shippedQuantity?: number;
}

/**
 * Check if a given object implements the ConsignmentEntry interface.
 */
export function instanceOfConsignmentEntry(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ConsignmentEntryFromJSON(json: any): ConsignmentEntry {
    return ConsignmentEntryFromJSONTyped(json, false);
}

export function ConsignmentEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsignmentEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderEntry': !exists(json, 'orderEntry') ? undefined : OrderEntryFromJSON(json['orderEntry']),
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'shippedQuantity': !exists(json, 'shippedQuantity') ? undefined : json['shippedQuantity'],
    };
}

export function ConsignmentEntryToJSON(value?: ConsignmentEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'orderEntry': OrderEntryToJSON(value.orderEntry),
        'quantity': value.quantity,
        'shippedQuantity': value.shippedQuantity,
    };
}

